/**
 * @generated SignedSource<<55f2c172f54034ca3e4e396db59315f9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VerifyCodeStep_session$data = {
  readonly currentClientProfile: {
    readonly member: {
      readonly club: {
        readonly name: string;
      };
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "VerifyCodeStep_session";
};
export type VerifyCodeStep_session$key = {
  readonly " $data"?: VerifyCodeStep_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"VerifyCodeStep_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VerifyCodeStep_session",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentClientProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "member",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Club",
              "kind": "LinkedField",
              "name": "club",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "b940eeaeb1dbc3482f8fb1252267ebdd";

export default node;
